export function executeOnTV(onTv, notOnTv) {
  try {
    if (VK_DOWN && onTv) {
      onTv();
    }
  } catch (e) {
    if (notOnTv) {
      notOnTv();
    }
  }
}
